
        <div class="switch__container text-center" (click)="toggleState($event)">
            <button data-test-id="SwitchShopper" class="switch__button left-item">buyer</button>
            <button data-test-id="SwitchShopperSeller" class="switch__button right-item">buyer &amp; seller</button>
        </div>
    